export default __webpack_public_path__ + "media/bundles/Sso/src/components/templates/RegisterTemplate/message_square-65f767278dd20e7c8feeccc5c3e4ae7b.svg";